export const HOUR_HEIGHT_EM = 3.5;

// Short events still get a card tall enough for one line of title at the Default
// text size (scaled up for Large); packing uses the same floor so two short
// events that would visually collide go side by side.
export const MIN_EVENT_MINUTES = 30;

export const COLUMN_MIN_WIDTH = '9em';
export const GUTTER_WIDTH = '3.75em';
